module.exports = __webpack_public_path__ + "static/media/icon-arrow-forward.35a811bd.svg";